export default {
  data() {
    return {
      error: null,
      errorBack: false,
      overlay: false,
      dialogError: false
    }
  },
  methods: {
    esFechaExamen(payload) {
      return this.$http.post('alumnos.esfechaexamen', payload)
      .then(res => res)
      .catch(error => {
        this.handleError(error);
      });
    },

    async verificarSiPuedeHacerJustificacion(payload){

      const puedoJustificar = await this.$http.post('alumnos.buscar.justificacion', payload)
      .then(res => res)
      .catch(error => {
        this.handleError(error);
      });

      return puedoJustificar.data

    },

    agregarJustificacion(payload) {
      return this.$http.post('alumnos.add.justificacion', payload)
      .then(res => res)
      .catch(error => {
        this.handleError(error);
      });
    },

    handleError(error) {
      if (error.body && error.body.message) {
        this.error = error.body.message;
      } else {
        this.error = error.body || "Error desconocido";
      }
      this.errorBack = true;
      this.overlay = false;
      this.dialogError = true;
    }
  }
}
